var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEnvironmentCardIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 35.652H3l6.479-6.123c.21-.2.488-.31.778-.311h21.287a1.143 1.143 0 0 1 .852.388L38 35.652Z",
    fill: "#4FC2B1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 35.652h35v.797a1.14 1.14 0 0 1-1.14 1.14H4.14A1.14 1.14 0 0 1 3 36.448v-.797Z",
    fill: "#5FE8C9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.892 19.964a7.35 7.35 0 0 0-6.398-7.078A9.275 9.275 0 0 0 20.928 4a9.547 9.547 0 0 0-9.1 6.203A8.789 8.789 0 0 0 4.05 18.66a8.944 8.944 0 0 0 9.295 8.672h16.158a7.466 7.466 0 0 0 7.389-7.37Z",
    fill: "url(#a)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m15.367 16.561 5.133-5.036a.582.582 0 0 1 .836 0l4.997 5.036a.253.253 0 0 1-.194.447h-3.15a.292.292 0 0 0-.272.273l-.04 9.86a.214.214 0 0 1-.214.215h-3.384a.214.214 0 0 1-.214-.214l.04-9.861a.272.272 0 0 0-.252-.273h-3.111a.252.252 0 0 1-.175-.447Z",
    fill: "#F2F2F2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 20.5,
    y1: 27.236,
    x2: 20.5,
    y2: 4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0078D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1380DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#3C91E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#559CEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EA0EF"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEnvironmentCardIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/environment-card-icon.6efcfda132f40919435c38b3551e9c65.svg";